function getPurchaseTypes(purchaseTypeContainer) {
    if (!purchaseTypeContainer) {
        return undefined;
    }
    return {
        title: !!purchaseTypeContainer.title ? purchaseTypeContainer.title : undefined,
        purchaseTypes: purchaseTypeContainer.purchaseType.map((purchaseType)=>{
            var ref;
            return {
                title: purchaseType.title,
                key: purchaseType.key,
                description: !!(purchaseType === null || purchaseType === void 0 ? void 0 : (ref = purchaseType.description) === null || ref === void 0 ? void 0 : ref.value) ? purchaseType.description.value : undefined,
                badgeText: !!purchaseType.badgeText ? purchaseType.badgeText : undefined
            };
        })
    };
}

export { getPurchaseTypes };
//# sourceMappingURL=get-purchase-types.js.map
